<template>
  <form @submit.prevent="$emit('submit', form)">
    <WCFormGroup>
      <label for="change-password-form__old-password"
        >{{ $t('oldPassword') }}<span class="text-danger"> *</span></label
      >
      <WCPasswordInput
        id="change-password-form__old-password"
        v-model="form.oldPassword"
        :vuelidate-object="$v.form.oldPassword"
        autocomplete="section-register current-password"
      />
    </WCFormGroup>
    <WCFormGroup>
      <label for="change-password-form__new-password"
        >{{ $t('newPassword') }}<span class="text-danger"> *</span></label
      >
      <WCNewPasswordInput
        id="change-password-form__new-password"
        v-model="form.password"
        autocomplete="section-register new-password"
        :$v="$v"
      />
    </WCFormGroup>

    <button type="submit" class="btn btn-primary btn-block submit-btn" :disabled="$v.form.$invalid">
      {{ $t('changePassword') }}
    </button>
  </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { password } from '@/utils/validators/validators';
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCPasswordInput from '@/modules/forms/components/WCPasswordInput/WCPasswordInput.vue';
import WCNewPasswordInput from '@/modules/forms/components/WCNewPasswordInput/WCNewPasswordInput.vue';

export default {
  components: { WCFormGroup, WCPasswordInput, WCNewPasswordInput },
  data() {
    return {
      form: {
        oldPassword: '',
        password: '',
      },
      passwordHidden: true,
    };
  },
  methods: {
    submit() {
      this.$emit('submit', this.form);
    },
  },
  validations: {
    form: {
      oldPassword: {
        required,
      },
      password: {
        required,
        password: password(),
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
